import { defineRoute } from "src/routing/defineRoute";
import { developmentRoute } from "src/routing/domains/developments/detail/developmentDetailPaths";

/**
 * Path + typed URL builder pairs for development change-log routes.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const developmentChangeLogRoute = defineRoute(`${developmentRoute.path}/change-log`);
export const developmentChangeLogDetailsRoute = defineRoute(`${developmentRoute.path}/change-log/:changeRequestId`);
